/* @flow */

//----------------------------------------------------------------------//
// GLOBAL IMPORTS
//----------------------------------------------------------------------//

import * as React from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

//----------------------------------------------------------------------//
// LOCAL IMPORTS
//----------------------------------------------------------------------//

import ElectroUseOriginal from 'forms/components/inputs/ElectroUseOriginal/ElectroUseOriginal';
import ElectroDatePicker from 'forms/components/inputs/ElectroDatePicker/ElectroDatePicker';

//----------------------------------------------------------------------//
// REACT COMPONENT
//----------------------------------------------------------------------//

type TypeProps = {|
  form: Object,
  setMode: Function,
  inEditMode: boolean,
|} & TranslatorProps;

@translate()
@observer
export default class RentalAssetExtensionRequest extends React.Component<*> {
  render(): React.Element<*> {
    const { t, form, setMode, inEditMode }: TypeProps = this.props;

    return (
      <div>
        <h5>{t('general:labels.new_rental_end_date')}</h5>
        <ElectroUseOriginal
          field={form.$('rentalExtension.end_date')}
          type="date"
          label={t('general:labels.use_original')}
          altLabel={t('general:labels.change_end_date')}
          setMode={setMode}
          inEditMode={inEditMode}
          input={<ElectroDatePicker field={form.$('rentalExtension.end_date')} />}
        />
      </div>
    );
  }
}
